import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconCart extends MeasurIcon<SVGProps<SVGSVGElement>> {
  render() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M7.50001 18.3333C7.96024 18.3333 8.33334 17.9602 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9602 7.03977 18.3333 7.50001 18.3333Z"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6667 18.3333C17.1269 18.3333 17.5 17.9602 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9602 16.2064 18.3333 16.6667 18.3333Z"
          stroke="currentColor"
          strokeWidth="1.66667"
        />
        <path
          d="M0.833328 0.833328H4.16666L6.39999 11.9917C6.4762 12.3753 6.68492 12.72 6.98962 12.9652C7.29431 13.2105 7.67558 13.3408 8.06666 13.3333H16.1667C16.5577 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.72 17.7571 12.3753 17.8333 11.9917L19.1667 5H4.99999"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <clipPath id="clip0_201_2981">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }
}
